module.exports = __webpack_public_path__ + "static/media/batch.bad4aa47.jpeg";